import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { useT } from "../i18n/I18nProvider";
import { formatMoneyFr } from "../lib/format";
import { cityIntros } from "../data/cityIntros";

// Mirrors the resolution order used by CityCard.jsx so the average rent shown
// on the homepage stays in sync with the comparator (Numbeo first, legacy
// housing_summary fallback). Keep these helpers literally identical.
function findIndicator(indicators, category, key) {
  if (!indicators) return null;
  const list = indicators[category] || [];
  return list.find((i) => i.key === key) || null;
}

export default function CityLivingCard({ city }) {
  const { t, lp } = useT();
  const slug = city.city_slug || city.slug;
  const name = city.city_name || city.name_fr;

  const nb = city.numbeo;
  const rentInd = findIndicator(nb?.indicators, "loyers", "rent_1br_center");
  const rentDisplay = rentInd?.avg ?? city.rent_avg ?? null;

  const intro = cityIntros[slug];

  return (
    <article
      className="hej-card overflow-hidden flex flex-col"
      data-testid={`city-living-card-${slug}`}
    >
      <div className="aspect-[16/10] overflow-hidden bg-slate-100">
        {city.image_url && (
          <img
            src={city.image_url}
            alt={name}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        )}
      </div>
      <div className="p-6 flex flex-col flex-1">
        <h3 className="font-display font-semibold text-xl text-slate-900">
          {name}
        </h3>
        {intro && (
          <p className="text-sm text-slate-600 leading-relaxed mt-3">{intro}</p>
        )}
        {rentDisplay !== null && (
          <p
            className="text-sm text-slate-500 mt-4"
            data-testid={`city-living-card-rent-${slug}`}
          >
            {t("housing.rent1brCenter")} :{" "}
            <span className="font-semibold text-slate-900 tabular-nums">
              {formatMoneyFr(rentDisplay)}
            </span>
          </p>
        )}
        <Link
          to={lp(`/villes/${slug}`)}
          className="mt-5 inline-flex items-center gap-1.5 text-sm font-medium text-[#0056D2] hover:gap-2 transition-all self-start"
          data-testid={`city-living-card-link-${slug}`}
        >
          {t("home.cities.discoverCta")} {name}
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </article>
  );
}
